import React from "react";
import styled from "styled-components";
import {InertiaLink, usePage} from '@inertiajs/inertia-react';

const Wrapper = styled.div`
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
    padding: 15px 15px;
    font-size: 20px;
    display: block;
    border-radius: 20px;
    margin-bottom: 30px;
    position: relative;
`;

const Grid = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const StatusBadge = styled.div`
    background: grey;
    padding: 5px 10px;
    color: white;
    border-radius: 5px;
    font-size: 13px;
    text-align: center;
`;

const StatusBadgeGreen = styled.div`
    background: Limegreen;
    padding: 5px 10px;
    color: white;
    border-radius: 5px;
    font-size: 13px;
    text-align: center;
`;

const StatusBadgeGrey = styled.div`
    background: Grey;
    padding: 5px 10px;
    color: white;
    border-radius: 5px;
    font-size: 13px;
    text-align: center;
`;

const StatusBadgeBlue = styled.div`
    background: Deepskyblue;
    padding: 5px 10px;
    color: white;
    border-radius: 5px;
    font-size: 13px;
    text-align: center;
`;

const StatusBadgeRed = styled.div`
    background: Red;
    padding: 5px 10px;
    color: white;
    border-radius: 5px;
    font-size: 13px;
    text-align: center;
`;

const BadgeB2XColor = styled.div`
    background: #e72364;
    padding: 5px 10px;
    margin-right: 5px;
    color: white;
    border-radius: 5px;
    font-size: 13px;
    text-align: center;
`;

const ArrowIcon = styled.svg`
    position: absolute;
    bottom: 14px;
    right: 30px;
`;

const Heading = styled.h3`
    margin: 0;
    font-size: 18px;
`;
const Text = styled.p`
    margin: 0;
    font-size: 15px;
`;
const TextDate = styled.p`
    margin: 0;
    font-size: 16px;
`;

export function QueueRowCompact({ row, returnUrl }) {
    const { defaultFilter } = usePage().props;
    return <Wrapper>
        <Grid>
            <div style={{ width: '50%' }}>
                <Text>{row.partner?.name}</Text>
                <Heading>{ row.installation_address?.name }</Heading>
                <Text>{ row.installation_address?.street } { row.installation_address?.housenumber }</Text>
                <Text>{ row.installation_address?.zip } { row.installation_address?.city }</Text>
                <br />
                <Text>{ row.number }</Text>
                <Text>{row.service}</Text>
                <Text>{row.products[0]?.description}</Text>
                <Text>{row.products[0]?.serialnumber}</Text>
            </div>
            <Grid style={{ width: '50%', textAlign: 'right' }}>
                {
                row.orderattributes
                    .filter(item => item.key === 'sla')
                    .map((attribute) => (
                        <div><BadgeB2XColor>{attribute.value}</BadgeB2XColor></div>
                ))
                }
                {
                    row.status?.currentStatus?.key == 'created' &&
                    <div>
                        <StatusBadgeBlue>{row.status?.currentStatus?.name}</StatusBadgeBlue>
                        <TextDate>{row.appointment_date}</TextDate>
                    </div>
                }
                {
                    row.status?.currentStatus?.key == 'appointment' &&
                    <div>
                        <StatusBadgeGreen>{row.status?.currentStatus?.name}</StatusBadgeGreen>
                        <TextDate>{row.appointment_date}</TextDate>
                    </div>
                }
                {
                    row.status?.currentStatus?.key == 'closed' &&
                    <div>
                        <StatusBadgeGrey>{row.status?.currentStatus?.name}</StatusBadgeGrey>
                        <TextDate>{row.completion_datetime}</TextDate>
                    </div>
                }
                {
                    row.status?.currentStatus?.key == 'blocked' &&
                    <div>
                        <StatusBadgeRed>{row.status?.currentStatus?.name}</StatusBadgeRed>
                        <TextDate>{row.appointment_date}</TextDate>
                    </div>
                }
                {
                    row.status?.currentStatus?.key != 'closed' && row.status?.currentStatus?.key != 'appointment' && row.status?.currentStatus?.key != 'created' && row.status?.currentStatus?.key != 'blocked' &&
                    <div>
                        <StatusBadge>{row.status?.currentStatus?.name}</StatusBadge>
                        <TextDate>{row.appointment_date}</TextDate>
                    </div>
                }
            </Grid>
        </Grid>

        <InertiaLink href={route('queue.details', { order: row.order_id, returnUrl: returnUrl })}>
            <ArrowIcon width="14" height="22" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 2L11 11L2 20" stroke="black" strokeWidth="3"/>
            </ArrowIcon>
        </InertiaLink>

    </Wrapper>
}
